import appRoute from "../../views/appRoutes/route.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("route", {
    url: "route/:id",
    parent: "app",
    views: {
      view: {
        template: appRoute,
      },
    },
    data: { title: "Route" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/route/route.urls.js